import React from "react";
import {
  aboutIntro,
  aboutFacts,
  aboutExperienceAreas,
} from "../../data/about";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-mutedColor px-6 border-r-[1px] border-r-lineColor flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">{aboutIntro.greeting}</h2>
          <p className="text-base leading-6">
            {aboutIntro.lines.map((line, index) => (
              <React.Fragment key={line}>
                {index > 0 && <br />}
                {"> "}
                {line}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          {aboutFacts.map(({ label, value }) => (
            <li key={label} className="aboutRightLi">
              <span className="aboutRightLiSpan">{label}</span>
              {value}
            </li>
          ))}
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Experience:</span>
          </li>
          {aboutExperienceAreas.map((area) => (
            <li
              key={area}
              className="text-mutedColor text-base font-normal border-b-[1px] border-lineColor py-2 pl-2"
            >
              • {area}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
